import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Api from '../api/api';
import Enums from '../../utilities/enum';
import Loader from '../shared/loader';
import stringHelpers from '../../utilities/stringHelpers';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterDisplay } from '../shared/appliedFilterDisplay';
import { ClientsFiltersModal } from './clientsFiltersModal';

function Clients(props) {
    const [clients, setClients] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [type, setType] = useState(null);
    const [status, setStatus] = useState(null);
    const [city, setCity] = useState(null);
    const [search, setSearch] = useState(null);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [cityFilterList, setCityFilterList] = useState(null);
    const clientAddUrl = "/organisation/" + props.organisationId + "/client"

    const getClients = function () {
        setIsLoading(true);
        Api.getClients(
            (data) => { setClients(data); setIsLoading(false); },
            () => { setClients(null); setIsLoading(false); },
            props.organisationId,
            props.token
        );
    };

    const setCityList = function () {
        if (clients !== null && clients !== undefined) {
            var list = new Array();
            clients.forEach(client => {
                if (!list.includes(client.townOrCity)) {
                    list.push(client.townOrCity);
                }
            });
            setCityFilterList(list.sort((a, b) => a.localeCompare(b)));
        }
    };

    const clearFilters = function () {
        setCity(null);
        setStatus(null);
        setType(null);
        setAppliedFilters(null);
        setShowFilterPills(false);
    };

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "City":
                setCity(null)
                break
            case "Type":
                setType(null)
                break
            case "Status":
                setStatus(null)
                break
            default:
                break
        }
    }

    useEffect(() => {
        getClients();
    }, []);

    useEffect(() => {
        setCityList()
    }, [clients]);
    return (
        <>
            {isLoading && <Loader />} {!isLoading && clients && clients !== null && <>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Your Clients</h5>
                                        </div>
                                        <div className="col-auto d-flex align-items-center text-right pl-0">
                                            <div className='mr-2'>
                                                <SearchBarWithDebounce
                                                    onSearchQueryChange={query => setSearch(query)}
                                                />
                                            </div>
                                            <div className='mr-2'>
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                            <Link className="btn btn-success btn-sm ml-1 nowrap" to={clientAddUrl}><i className="fas fa-plus"></i> Add</Link>
                                        </div>
                                    </div>
                                </div>
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => !stringHelpers.isNullOrEmpty(value)
                                                && <div className="mr-2" key={label}>
                                                    <AppliedFilterDisplay
                                                        label={label}
                                                        onTextClick={() => setShowFiltersModal(true)}
                                                        onCloseClick={closedLabel => {
                                                            clearFilterByLabel(closedLabel)
                                                            setAppliedFilters(prevState => {
                                                                const updatedFilters = { ...prevState }
                                                                updatedFilters[closedLabel] = null
                                                                const hasRemainingFilters = Object.values(updatedFilters).some(value => !stringHelpers.isNullOrEmpty(value))
                                                                return hasRemainingFilters ? updatedFilters : null
                                                            })
                                                        }}
                                                        value={value}
                                                    />
                                                </div>
                                            )
                                        }
                                        {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                                    </div>
                                }
                                <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th>Client Name</th>
                                            <th>Town/City</th>
                                            <th>Type</th>
                                            <th className="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {clients.filter(function (client) {
                                            var townOrCity = new String(client.townOrCity).toLowerCase();
                                            var name = new String(client.name).toLowerCase();
                                            return ((client.townOrCity === city || city === null) && (client.clientType === type || type === null) && (client.isActive === status || status === null) && (search === null || townOrCity.search(search.toLowerCase()) !== -1 || name.search(search.toLowerCase()) !== -1))
                                        }).map((client) => {
                                            var url = "/organisation/"+ props.organisationId+"/client/" + client.id;
                                            return (
                                                <tr>
                                                    <td><Link to={url}><h6 className="mb-0">{client.name}</h6></Link></td>
                                                    <td>{client.townOrCity}</td>
                                                    <td>{Enums.ClientTypes[client.clientType]}</td>
                                                    <td className="text-center">{client.isActive && <><i className="fas fa-check text-success"></i></>}{!client.isActive && <><i className="fas fa-times text-danger"></i></>}</td>
                                                </tr>)
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showFiltersModal &&
                    <ClientsFiltersModal
                        showModal={showFiltersModal}
                        handleClose={() => setShowFiltersModal(false)}
                        handleConfirm={(draftFilters) => {
                            setCity(draftFilters.city)
                            setType(draftFilters.type)
                            setStatus(draftFilters.status)
                            setAppliedFilters(draftFilters.appliedFilters)
                            setShowFilterPills(true)
                            setShowFiltersModal(false)
                        }}
                        initialCity={city}
                        initialType={type}
                        initialStatus={status}
                        initialAppliedFilters={appliedFilters}
                        cityOptions={cityFilterList ?? []}
                        key="clients-filters-modal"
                    />
                }
            </>}
        </>
    )
}

export default Clients;